__turbopack_context__.v({
  "container": "uiodHq_container",
});
